/**
 * Cờ 3 nước: Vietnam, UK (England), Netherlands – SVG rõ ràng
 */
import type { AppLanguage } from "../../contexts/LiveAPIContext";

type FlagIconProps = {
  lang: AppLanguage;
  className?: string;
};

function FlagIconVN({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 16" className={className} aria-hidden xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="16" fill="#DA251D" />
      <path
        fill="#FFFF00"
        d="M12 4.2L13.4 8.5H18L14.3 11l1.4 4.3L12 12.2 8.3 15l1.4-4.3L6 8.5h4.6L12 4.2z"
      />
    </svg>
  );
}

function FlagIconUK({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 16" className={className} aria-hidden xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="16" fill="#012169" />
      <path stroke="#fff" strokeWidth="3" fill="none" d="M12 0v16M0 8h24" />
      <path stroke="#C8102E" strokeWidth="2" fill="none" d="M12 0v16M0 8h24" />
      <path stroke="#fff" strokeWidth="2" fill="none" d="M0 0l24 16M24 0L0 16" />
      <path stroke="#C8102E" strokeWidth="1" fill="none" d="M0 0l24 16M24 0L0 16" />
    </svg>
  );
}

function FlagIconNL({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 16" className={className} aria-hidden xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="16" fill="#AE1C28" />
      <rect y="5.33" width="24" height="5.33" fill="#FFF" />
      <rect y="10.67" width="24" height="5.33" fill="#21468B" />
    </svg>
  );
}

export function FlagIcon({ lang, className }: FlagIconProps) {
  if (lang === "vi") return <FlagIconVN className={className} />;
  if (lang === "en") return <FlagIconUK className={className} />;
  return <FlagIconNL className={className} />;
}
